module.exports = __webpack_public_path__ + "14b19efc67e14980a5e966ef3e6850fd.png";


//////////////////
// WEBPACK FOOTER
// ./content/help/research/insilico/scoring-img/img7.png
// module id = 1326
// module chunks = 0